type InvalidError = { type: "INVALID" };
type TooShortError = { type: "TOO_SHORT"; minLength: number };
type TooLongError = { type: "TOO_LONG"; maxLength: number };
type InvalidLengthError = { type: "INVALID_LENGTH"; expectedLength: number };

export const NAME_MIN_LENGTH = 3;
export const NAME_MAX_LENGTH = 32;
export const TEAM_IDENTIFIER_LENGTH = 3;
export const DESCRIPTION_MAX_LENGTH = 50;

// validation functions based on `scalars.rs` file
export const validateEmail = (email: string): InvalidError | undefined => {
  const regex =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*\.+[a-z]+/;
  if (!regex.test(email)) {
    return { type: "INVALID" };
  }
};

export const validateSlug = (
  slug: string,
): TooShortError | TooLongError | InvalidError | undefined => {
  if (slug.length < NAME_MIN_LENGTH) {
    return { type: "TOO_SHORT", minLength: NAME_MIN_LENGTH };
  }
  if (slug.length > NAME_MAX_LENGTH) {
    return { type: "TOO_LONG", maxLength: NAME_MAX_LENGTH };
  }

  const regex = /^[a-zA-Z0-9_-]+$/;
  if (!regex.test(slug)) {
    return { type: "INVALID" };
  }
};

export const validateName = (
  name: string,
): TooShortError | TooLongError | InvalidError | undefined => {
  if (name.length < NAME_MIN_LENGTH) {
    return { type: "TOO_SHORT", minLength: NAME_MIN_LENGTH };
  }
  if (name.length > NAME_MAX_LENGTH) {
    return { type: "TOO_LONG", maxLength: NAME_MAX_LENGTH };
  }

  const regex = /^[a-zA-ZÀ-ÿ -']+$/;
  if (!regex.test(name)) {
    return { type: "INVALID" };
  }
};

export const validateTeamIdentifier = (
  teamIdentifier: string,
): InvalidLengthError | InvalidError | undefined => {
  if (teamIdentifier.length !== TEAM_IDENTIFIER_LENGTH) {
    return { type: "INVALID_LENGTH", expectedLength: TEAM_IDENTIFIER_LENGTH };
  }

  const regex = /^[A-Z]+$/;
  if (!regex.test(teamIdentifier)) {
    return { type: "INVALID" };
  }
};

export const validateDescription = (description: string): TooLongError | undefined => {
  if (description.length > DESCRIPTION_MAX_LENGTH) {
    return { type: "TOO_LONG", maxLength: DESCRIPTION_MAX_LENGTH };
  }
};
